
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
    import store from '../../../store'
    import CollectInOut from  './collect-in-out'
    import Export from './export'
    import {isAuth} from "@/utils/user";
    import AddOrUpdate from "./kq-collect-data-add-or-update"
    @Component({
        name:'kqtj',
        components:{
            Export,
            CollectInOut,
            AddOrUpdate
        }
    })
    export default class kqtj extends Vue {
        currentTime = this.$moment().subtract(1,'months').toDate()
        maxMonth = this.$moment().subtract(1,'months')
        select=''
        tableLoad = false;
        batchVisible=false;
        exportVisiable= false
        depts=[]
        dept=''
        addOrUpdateVisible=false
        searchName=''
        dataNum=''
        searchGw=''
        childDept=''
        childDepts=[]
        deptdisable=false
        childdeptdisable=false
        currentPage=1  //当前页
        countsize=0   //总条目数
        collectInfo: {id:string,status?: number,month:string}={id:'',month:''}
        dataList = []
        mounted() {
            this.getDepts()
            this.getData()
        }


        exportExcel(){
            let month = this.$moment(this.currentTime).format('YYYY-MM')
            if (this.collectInfo.status && this.collectInfo.status === 1) {

                var viewUrl = this.$request.defaults.baseURL + '/bjba/kqtj/exportExcelCollectAll?date=' + month + '&access_token=' + this.$store.getters.token
                window.open(viewUrl)
            } else this.$message.error(`${month} 暂时没有数据`)

        }

        updateHanlder(val:string) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(val)
            })
        }

        getDepts(){
            let user=store.getters.user;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                this.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc){
                        if(zzdyqc != this.CONST_ZN_BM) {
                            var zw = this.$store.getters.user.zw;

                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.dept = this.depts[0].bmid
                                    this.deptdisable = true
                                    if(zw !='01') {
                                        this.childdeptdisable =true;
                                    }

                                }
                            }
                        }

                    }

                }
                // this.selectChanged2(this.dept)
            })
        }
       /* selectChanged2(value) {
            this.currentPage =1
            this.childDepts = []
            this.childDept =''
            this.$request({
                method: 'get',
                url: '/bjba/kqtj/getMentForUser2',
                params: {
                    fbmid: value,
                    userid:this.$store.getters.username
                }
            }).then((response) => {
                this.childDepts = response.data;
                var zzdyqc = this.$store.getters.user.zzdyqc;
                if(zzdyqc){
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;

                        if(zw) {
                            if(zw=='02'||zw=='03') {
                                if(this.childDepts[0]) {
                                    this.childDept = this.childDepts[0].bmid

                                }
                            }
                        }
                    }

                }

            }).catch((err) => {
                console.log(err)
            })
        }*/
        selectChanged(){
            this.currentPage =1;
            this.getkqData()
        }
        getData() {
            // this.tableLoad = true
            let month = this.$moment(this.currentTime).format('YYYY-MM')
            this.$request.get(`/bjba/kqcollect/infoByMonth/${month}`).then(res => {
                this.collectInfo = res.data.data
               if(this.collectInfo.status === 1) {
                    this.getkqData()
               }
            })
        }
        showBatchinOut() {
            this.batchVisible = true
            this.$nextTick(() => {
                this.$refs.batchin.init()
            })
        }
        getkqData() {
            this.tableLoad = true
            this.$request({
                method: 'get',
                url:'/bjba/kqcollectData/list',
                params:{page:this.currentPage,pagesize:10,collectId:this.collectInfo.id,zzdyqc:this.dept,name:this.searchName,gw:this.searchGw}
            }).then(res => {
                this.tableLoad = false
                const {data} = res
                this.dataList = data.data.content
                this.countsize = data.data.totalElements
            }).catch(err => {
                this.$message({
                    message: '获取列表出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                this.tableLoad = false
                console.log(err)
            })
        }
        createKqCollect() {
            let month = this.$moment(this.currentTime).format('YYYY-MM')
            this.$request({
                method: 'post',
                url: '/bjba/kqcollect/createKqCollect',
                params: {month:month}
            }).then(res => {
                this.collectInfo = res.data.data

            }).catch((err) => {
                console.log(err)
            })
        }
        lastmonth(){
            this.currentTime = this.$moment(this.currentTime).subtract(1,'months').toDate()
            this.currentPage = 1
            this.countsize = 0
            this.dataList = []
            this.getData()

        }
        nextmonth(){
            this.currentTime = this.$moment(this.currentTime).add(1,'months').toDate()
            this.currentPage = 1
            this.countsize = 0
            this.dataList = []
            this.getData()
        }


        handleCurrentChange(){
            this.getkqData()
        }
        get canNextMonth() {
            return this.$moment(this.currentTime).isSame(this.maxMonth,'month')
            // return true
        }

    }
